// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cqdvqv0 {
  background-color: var(--_18w76bw25);
  padding-top: var(--_18w76bwt);
  padding-bottom: var(--_18w76bwt);
  padding-left: var(--_18w76bw9);
  flex-direction: column;
  width: var(--_18w76bw1r);
  gap: var(--_18w76bwh);
  margin-left: auto;
  margin-right: auto;
}
.cqdvqv1 {
  padding: var(--_18w76bwd);
  position: relative;
  background-color: var(--_18w76bw23);
  width: var(--_18w76bw1u);
}
.cqdvqv2 {
  padding: var(--_18w76bwh);
  text-align: center;
  line-height: var(--_18w76bw44);
  border-bottom: 1px solid #d8d8d8;
}
.cqdvqv3 {
  padding-left: var(--_18w76bwi);
  padding-right: var(--_18w76bwi);
  padding-top: var(--_18w76bwh);
  padding-bottom: var(--_18w76bwg);
  gap: var(--_18w76bwm);
  flex-direction: column;
}
.cqdvqv4 {
  border-bottom: 1px solid #d8d8d8;
  padding-bottom: var(--_18w76bwd);
}
.cqdvqv5 {
  list-style-type: none;
}
.cqdvqv5::before {
  content: "-";
  margin-right: 6px;
  font-weight: bold;
}
.cqdvqv5::marker {
  content: "";
}
@media screen and (max-width: 767px) {
  .cqdvqv0 {
    padding-top: var(--_18w76bw9);
    padding-bottom: var(--_18w76bwd);
    width: var(--_18w76bw1u);
    margin-left: var(--_18w76bw9);
    margin-right: var(--_18w76bw9);
    gap: var(--_18w76bwd);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;EACvB;AACF","sourcesContent":[".cqdvqv0 {\n  background-color: var(--_18w76bw25);\n  padding-top: var(--_18w76bwt);\n  padding-bottom: var(--_18w76bwt);\n  padding-left: var(--_18w76bw9);\n  flex-direction: column;\n  width: var(--_18w76bw1r);\n  gap: var(--_18w76bwh);\n  margin-left: auto;\n  margin-right: auto;\n}\n.cqdvqv1 {\n  padding: var(--_18w76bwd);\n  position: relative;\n  background-color: var(--_18w76bw23);\n  width: var(--_18w76bw1u);\n}\n.cqdvqv2 {\n  padding: var(--_18w76bwh);\n  text-align: center;\n  line-height: var(--_18w76bw44);\n  border-bottom: 1px solid #d8d8d8;\n}\n.cqdvqv3 {\n  padding-left: var(--_18w76bwi);\n  padding-right: var(--_18w76bwi);\n  padding-top: var(--_18w76bwh);\n  padding-bottom: var(--_18w76bwg);\n  gap: var(--_18w76bwm);\n  flex-direction: column;\n}\n.cqdvqv4 {\n  border-bottom: 1px solid #d8d8d8;\n  padding-bottom: var(--_18w76bwd);\n}\n.cqdvqv5 {\n  list-style-type: none;\n}\n.cqdvqv5::before {\n  content: \"-\";\n  margin-right: 6px;\n  font-weight: bold;\n}\n.cqdvqv5::marker {\n  content: \"\";\n}\n@media screen and (max-width: 767px) {\n  .cqdvqv0 {\n    padding-top: var(--_18w76bw9);\n    padding-bottom: var(--_18w76bwd);\n    width: var(--_18w76bw1u);\n    margin-left: var(--_18w76bw9);\n    margin-right: var(--_18w76bw9);\n    gap: var(--_18w76bwd);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
